exports = module.exports = require("../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".viewport[data-v-54df6e7e]{position:relative}.viewport canvas[data-v-54df6e7e],.viewport video[data-v-54df6e7e]{position:absolute;left:0;top:0}", ""]);

// exports
